import { createFileRoute } from "@tanstack/react-router";

import { EmailLinkPage, type EmailStop } from "../../features/news/EmailLinkPage";

// Outside the signed-in and signed-out layouts: the link of an email is enough, signed in or not.
export const Route = createFileRoute("/emails/$token")({
  validateSearch: (search: Record<string, unknown>): { stop: EmailStop } => ({
    stop: search["stop"] === "nudges" ? "nudges" : "news",
  }),
  component: function EmailLink() {
    return <EmailLinkPage token={Route.useParams().token} stop={Route.useSearch().stop} />;
  },
});
